const INTEGER = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
const DECIMAL = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 });
const CENTS = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// The DMS appends the paint finish as a second part: „GLACIER SILVER / Metallic“.
const FINISH_PART = /\s*\/\s*metallic\s*$/i;

export function isNumber(value: unknown): value is number {
    return typeof value === 'number' && Number.isFinite(value);
}

/** Consumption, rates and other measured values: up to two decimals, German separators. */
export function formatDecimal(value: number): string {
    return DECIMAL.format(value);
}

/** Whole euros — the Pkw-EnVKV cost figures and the price filter. */
export function formatEuro(value: number): string {
    return `${INTEGER.format(value)} €`;
}

/** Euros with cents where the amount has them — prices and financing figures. */
export function formatAmount(value: number): string {
    return `${Number.isInteger(value) ? INTEGER.format(value) : CENTS.format(value)} €`;
}

export function formatMileage(km: number): string {
    return `${INTEGER.format(km)} km`;
}

export function formatPower(kw?: number, ps?: number): string {
    if (!isNumber(kw)) return '';
    return isNumber(ps) ? `${INTEGER.format(kw)} kW (${INTEGER.format(ps)} PS)` : `${INTEGER.format(kw)} kW`;
}

export function formatPercent(value: number): string {
    return `${DECIMAL.format(value)} %`;
}

/** „GLACIER SILVER / Metallic“ → „GLACIER SILVER Metallic“, the form page, JSON-LD and feed share. */
export function formatColor(value?: string): string {
    const raw = value?.trim() ?? '';
    const name = raw.replace(FINISH_PART, '');

    return name !== raw && !/metallic/i.test(name) ? `${name} Metallic` : name;
}

/** „2021-07“ or „2026-11-15“ → „07/2021“ / „11/2026“; anything else stays empty. */
export function formatMonthYear(value?: string): string {
    const match = value?.match(/^(\d{4})-(\d{2})/);
    return match ? `${match[2]}/${match[1]}` : '';
}

/** Year of a „JJJJ-MM“ value, for the first-registration filter. */
export function yearOf(value?: string): number | undefined {
    const year = Number(value?.slice(0, 4));
    return year > 0 ? year : undefined;
}

/** „JJJJ-MM“ as a sortable number (202107). */
export function monthIndexOf(value?: string): number | undefined {
    const match = value?.match(/^(\d{4})-(\d{2})/);
    return match ? Number(match[1]) * 100 + Number(match[2]) : undefined;
}
